import BaseApiRequest from "./BaseApiRequest";
import { GLOBAL_VAULT_GET_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { formURL } from "../../Utils/CommonUtilities";

export default class GetApplicantVault extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = GLOBAL_VAULT_GET_URL;

  constructor(reqData) {
    super();
    const { vaultKey } = reqData;

    const paramList = [vaultKey];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
